import { Link } from 'react-router-dom';
import { EnvelopeSimple, Phone, MapPin, InstagramLogo, FacebookLogo, PinterestLogo } from '@phosphor-icons/react';

export function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-nexa-charcoal text-white" data-testid="footer">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div>
            <h3 className="font-serif text-2xl font-semibold mb-4">Nexaorbits</h3>
            <p className="text-white/70 text-sm leading-relaxed mb-6">
              Beautiful home decor to transform your living space. Discover stylish decor pieces designed to bring elegance, warmth, and personality to your home.
            </p>
            <div className="flex gap-4">
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="hover:text-nexa-gold transition-colors" data-testid="social-instagram">
                <InstagramLogo size={24} />
              </a>
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="hover:text-nexa-gold transition-colors" data-testid="social-facebook">
                <FacebookLogo size={24} />
              </a>
              <a href="https://pinterest.com" target="_blank" rel="noopener noreferrer" className="hover:text-nexa-gold transition-colors" data-testid="social-pinterest">
                <PinterestLogo size={24} />
              </a>
            </div>
          </div>

          {/* Shop */}
          <div>
            <h4 className="text-sm uppercase tracking-widest font-semibold mb-6">Shop</h4>
            <ul className="space-y-3">
              <li><Link to="/category/Wall Art" className="text-white/70 hover:text-nexa-gold transition-colors text-sm">Wall Art</Link></li>
              <li><Link to="/category/Decorative Lamps" className="text-white/70 hover:text-nexa-gold transition-colors text-sm">Decorative Lamps</Link></li>
              <li><Link to="/category/Throw Pillows" className="text-white/70 hover:text-nexa-gold transition-colors text-sm">Throw Pillows</Link></li>
              <li><Link to="/category/Vases & Planters" className="text-white/70 hover:text-nexa-gold transition-colors text-sm">Vases & Planters</Link></li>
              <li><Link to="/category/Home Fragrances" className="text-white/70 hover:text-nexa-gold transition-colors text-sm">Home Fragrances</Link></li>
              <li><Link to="/category/Mirrors" className="text-white/70 hover:text-nexa-gold transition-colors text-sm">Mirrors</Link></li>
            </ul>
          </div>

          {/* Info */}
          <div>
            <h4 className="text-sm uppercase tracking-widest font-semibold mb-6">Information</h4>
            <ul className="space-y-3">
              <li><Link to="/about" className="text-white/70 hover:text-nexa-gold transition-colors text-sm">About Us</Link></li>
              <li><Link to="/contact" className="text-white/70 hover:text-nexa-gold transition-colors text-sm">Contact Us</Link></li>
              <li><Link to="/shipping-policy" className="text-white/70 hover:text-nexa-gold transition-colors text-sm">Shipping Policy</Link></li>
              <li><Link to="/refund-policy" className="text-white/70 hover:text-nexa-gold transition-colors text-sm">Refund & Returns</Link></li>
              <li><Link to="/privacy-policy" className="text-white/70 hover:text-nexa-gold transition-colors text-sm">Privacy Policy</Link></li>
              <li><Link to="/terms" className="text-white/70 hover:text-nexa-gold transition-colors text-sm">Terms & Conditions</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-sm uppercase tracking-widest font-semibold mb-6">Contact Us</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin size={20} className="text-nexa-gold flex-shrink-0 mt-0.5" />
                <span className="text-white/70 text-sm">712 Greenfield Avenue, Detroit, MI 11201</span>
              </li>
              <li className="flex items-center gap-3">
                <Phone size={20} className="text-nexa-gold flex-shrink-0" />
                <a href="tel:+18883511122" className="text-white/70 hover:text-nexa-gold transition-colors text-sm">+1-888-351-1122</a>
              </li>
              <li className="flex items-center gap-3">
                <EnvelopeSimple size={20} className="text-nexa-gold flex-shrink-0" />
                <a href="mailto:support@nexaorbits.store" className="text-white/70 hover:text-nexa-gold transition-colors text-sm">support@nexaorbits.store</a>
              </li>
            </ul>
            <div className="mt-6">
              <p className="text-white/50 text-xs">Customer Support Hours:</p>
              <p className="text-white/70 text-sm">Mon - Fri: 9AM - 6PM EST</p>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-white/10 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-white/50 text-sm">
            © {currentYear} Nexaorbits. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <img src="https://cdn-icons-png.flaticon.com/128/349/349221.png" alt="Visa" className="h-6 opacity-70" />
            <img src="https://cdn-icons-png.flaticon.com/128/349/349228.png" alt="Mastercard" className="h-6 opacity-70" />
            <img src="https://cdn-icons-png.flaticon.com/128/349/349230.png" alt="Amex" className="h-6 opacity-70" />
            <img src="https://cdn-icons-png.flaticon.com/128/174/174861.png" alt="PayPal" className="h-6 opacity-70" />
          </div>
        </div>
      </div>
    </footer>
  );
}
